// src/pages/produtos/produtos/NCMSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { useNCM } from '../../../contexts/produtos/NCMContext';
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalTable from '../../../components/modalForm/ModalTable';
import LazyLoading from '../../../components/modalForm/LazyLoading';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';

import ModalSearchBar from '../../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../../components/modalForm/ModalActions';
import ModalSelectButton from '../../../components/modalForm/ModalSelectButton';

const NCMSearch = ({ show, onHide, onSelectNCM }) => {
    const { NCMs, fetchNCMs } = useNCM();
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('codigo');
    const [sortDirection, setSortDirection] = useState('asc');

    const inputRef = useRef(null);

    useEffect(() => {
        if (show) {
            fetchNCMs();
            setFilter('');

            if (inputRef.current) inputRef.current.focus();
        }
    }, [show]);

    if (!show) return null;

    const filteredNCMs = (NCMs || []).filter(ncm => {
        const codigoSemPonto = ncm.codigo?.replace(/\./g, '').toLowerCase();
        const filtroSemPonto = filter.replace(/\./g, '').toLowerCase();
        return (
            ncm.descricao.toLowerCase().includes(filter.toLowerCase()) ||
            codigoSemPonto.includes(filtroSemPonto)
        );
    });

    const sortedNCMs = [...filteredNCMs].sort((a, b) => {
        const valueA = a[sortField]?.toString().toLowerCase();
        const valueB = b[sortField]?.toString().toLowerCase();
        if (valueA < valueB) return sortDirection === 'asc' ? -1 : 1;
        if (valueA > valueB) return sortDirection === 'asc' ? 1 : -1;
        return 0;
    });

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (ncm) => {
        onSelectNCM(ncm);
        onHide();
    };

    return (
        <ModalContainer largura='700px' show={show} variant="busca" onHide={onHide}>
            <ModalHeader title="Buscar NCM" onHide={onHide} />

            <ModalBody>
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por código ou descrição..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>

                <LazyLoading items={sortedNCMs} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center align-middle" style={{ width: '20%' }} aria-sort={sortField === 'codigo' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button
                                    onClick={() => handleSort('codigo')}
                                    className="btn btn-link p-0 fw-bold"
                                    tabIndex={0}
                                 type="button">
                                    Código {sortField === 'codigo' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-start align-middle" style={{ width: '60%' }} aria-sort={sortField === 'descricao' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button
                                    onClick={() => handleSort('descricao')}
                                    className="btn btn-link p-0 fw-bold"
                                    tabIndex={0}
                                 type="button">
                                    Descrição {sortField === 'descricao' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" style={{ width: '20%' }}>
                                Selecionar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map((ncm) => (
                            <tr key={ncm?.id} onDoubleClick={() => handleDoubleClick(ncm)}>
                                <td className="text-center align-middle">{ncm?.codigo}</td>
                                <td className="text-start align-middle">{ncm?.descricao}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={() => {
                                            onSelectNCM(ncm);
                                            onHide();
                                        }}
                                     label={ncm?.descricao} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>

            <ModalFooter>

                <ModalActionButton className="btn btn-secondary btn-sm" onClick={onHide} action="close">Fechar</ModalActionButton>
            </ModalFooter>
        </ModalContainer>
    );
};

export default NCMSearch;